export const EVERYNOISE_GENRES = Object.freeze(
{
    "canadian contemporary r&b": {
        "frequency": 1,
        "average_age": 29.9,
        "percent_female": 51.7
    },
    "canadian pop": {
        "frequency": 1,
        "average_age": 34.0,
        "percent_female": 54.4
    },
    "pop": {
        "frequency": 2,
        "average_age": 28.9,
        "percent_female": 59.1
    },
    "mexican metal": {
        "frequency": 1,
        "average_age": 32.8,
        "percent_female": 13.4
    },
    "monterrey indie": {
        "frequency": 1,
        "average_age": 29.5,
        "percent_female": 33.8
    },
    "edmonton indie": {
        "frequency": 1,
        "average_age": 34.5,
        "percent_female": 38.0
    },
    "lo-fi indie": {
        "frequency": 1,
        "average_age": 26.5,
        "percent_female": 37.9
    },
    "pov: indie": {
        "frequency": 3,
        "average_age": 25.1,
        "percent_female": 50.9
    },
    "slacker rock": {
        "frequency": 1,
        "average_age": 0,
        "percent_female": 0
    },
    "hard rock": {
        "frequency": 8,
        "average_age": 40.2,
        "percent_female": 20.3
    },
    "metal": {
        "frequency": 8,
        "average_age": 35.2,
        "percent_female": 13.9
    },
    "colombian pop": {
        "frequency": 1,
        "average_age": 31.9,
        "percent_female": 57.1
    },
    "latin pop": {
        "frequency": 2,
        "average_age": 35.2,
        "percent_female": 57.5
    },
    "mexican pop": {
        "frequency": 2,
        "average_age": 34.1,
        "percent_female": 59.1
    },
    "rock en espanol": {
        "frequency": 1,
        "average_age": 34.1,
        "percent_female": 36.6
    },
    "art pop": {
        "frequency": 3,
        "average_age": 32.6,
        "percent_female": 44.2
    },
    "electropop": {
        "frequency": 1,
        "average_age": 31.1,
        "percent_female": 50.2
    },
    "escape room": {
        "frequency": 1,
        "average_age": 29.6,
        "percent_female": 41.0
    },
    "indie pop": {
        "frequency": 2,
        "average_age": 28.5,
        "percent_female": 59.1
    },
    "alternative rock": {
        "frequency": 2,
        "average_age": 35.9,
        "percent_female": 28.8
    },
    "modern power pop": {
        "frequency": 2,
        "average_age": 40.1,
        "percent_female": 24.0
    },
    "modern rock": {
        "frequency": 7,
        "average_age": 31.1,
        "percent_female": 39.0
    },
    "permanent wave": {
        "frequency": 1,
        "average_age": 37.4,
        "percent_female": 36.8
    },
    "rock": {
        "frequency": 11,
        "average_age": 36.9,
        "percent_female": 29.5
    },
    "north east england indie": {
        "frequency": 1,
        "average_age": 36.5,
        "percent_female": 37.7
    },
    "alternative country": {
        "frequency": 1,
        "average_age": 42.8,
        "percent_female": 28.1
    },
    "folk": {
        "frequency": 1,
        "average_age": 46.3,
        "percent_female": 36.7
    },
    "new americana": {
        "frequency": 1,
        "average_age": 39.1,
        "percent_female": 41.4
    },
    "roots rock": {
        "frequency": 2,
        "average_age": 46.5,
        "percent_female": 25.2
    },
    "latin alternative": {
        "frequency": 2,
        "average_age": 34.3,
        "percent_female": 36.7
    },
    "mexican indie": {
        "frequency": 2,
        "average_age": 31.2,
        "percent_female": 34.8
    },
    "mexican rock": {
        "frequency": 1,
        "average_age": 33.2,
        "percent_female": 29.2
    },
    "tropical alternativo": {
        "frequency": 1,
        "average_age": 35.5,
        "percent_female": 46.5
    },
    "mexican hip hop": {
        "frequency": 1,
        "average_age": 26.7,
        "percent_female": 17.1
    },
    "rap conciencia": {
        "frequency": 1,
        "average_age": 29.2,
        "percent_female": 22.1
    },
    "old school thrash": {
        "frequency": 7,
        "average_age": 36.5,
        "percent_female": 10.5
    },
    "thrash metal": {
        "frequency": 7,
        "average_age": 35.3,
        "percent_female": 10.2
    },
    "brighton indie": {
        "frequency": 1,
        "average_age": 33.7,
        "percent_female": 33.8
    },
    "garage rock": {
        "frequency": 1,
        "average_age": 36.1,
        "percent_female": 25.8
    },
    "modern alternative rock": {
        "frequency": 4,
        "average_age": 30.3,
        "percent_female": 34.0
    },
    "modern blues rock": {
        "frequency": 1,
        "average_age": 41.6,
        "percent_female": 20.1
    },
    "modern hard rock": {
        "frequency": 1,
        "average_age": 41.0,
        "percent_female": 16.2
    },
    "etherpop": {
        "frequency": 1,
        "average_age": 34.7,
        "percent_female": 46.6
    },
    "indie rock": {
        "frequency": 4,
        "average_age": 33.3,
        "percent_female": 37.3
    },
    "indietronica": {
        "frequency": 2,
        "average_age": 32.9,
        "percent_female": 38.3
    },
    "metropopolis": {
        "frequency": 1,
        "average_age": 33.1,
        "percent_female": 42.0
    },
    "neo-synthpop": {
        "frequency": 1,
        "average_age": 37.4,
        "percent_female": 31.3
    },
    "indie punk": {
        "frequency": 4,
        "average_age": 32.2,
        "percent_female": 29.2
    },
    "louisville indie": {
        "frequency": 2,
        "average_age": 33.6,
        "percent_female": 39.5
    },
    "k-rock": {
        "frequency": 1,
        "average_age": 29.6,
        "percent_female": 51.7
    },
    "korean indie rock": {
        "frequency": 1,
        "average_age": 27.0,
        "percent_female": 49.4
    },
    "scottish rock": {
        "frequency": 1,
        "average_age": 36.7,
        "percent_female": 30.6
    },
    "australian garage punk": {
        "frequency": 1,
        "average_age": 31.5,
        "percent_female": 23.3
    },
    "brisbane punk": {
        "frequency": 1,
        "average_age": 36.6,
        "percent_female": 21.1
    },
    "hardcore punk": {
        "frequency": 1,
        "average_age": 35.4,
        "percent_female": 15.2
    },
    "punk": {
        "frequency": 1,
        "average_age": 36.2,
        "percent_female": 18.7
    },
    "alternative emo": {
        "frequency": 1,
        "average_age": 29.5,
        "percent_female": 25.0
    },
    "bubblegrunge": {
        "frequency": 3,
        "average_age": 30.6,
        "percent_female": 38.0
    },
    "canadian indie": {
        "frequency": 1,
        "average_age": 37.2,
        "percent_female": 35.3
    },
    "canadian pop punk": {
        "frequency": 1,
        "average_age": 31.4,
        "percent_female": 22.2
    },
    "canadian punk": {
        "frequency": 1,
        "average_age": 36.8,
        "percent_female": 16.5
    },
    "emo": {
        "frequency": 1,
        "average_age": 31.4,
        "percent_female": 24.6
    },
    "toronto indie": {
        "frequency": 1,
        "average_age": 33.9,
        "percent_female": 39.7
    },
    "alternative metal": {
        "frequency": 1,
        "average_age": 33.4,
        "percent_female": 21.6
    },
    "nu metal": {
        "frequency": 1,
        "average_age": 33.9,
        "percent_female": 19.7
    },
    "post-grunge": {
        "frequency": 1,
        "average_age": 34.2,
        "percent_female": 26.4
    },
    "punk blues": {
        "frequency": 1,
        "average_age": 39.6,
        "percent_female": 20.9
    },
    "filmi": {
        "frequency": 1,
        "average_age": 27.9,
        "percent_female": 35.7
    },
    "modern bollywood": {
        "frequency": 1,
        "average_age": 25.4,
        "percent_female": 39.9
    },
    "desi hip hop": {
        "frequency": 1,
        "average_age": 23.9,
        "percent_female": 19.9
    },
    "desi trap": {
        "frequency": 1,
        "average_age": 22.9,
        "percent_female": 16.9
    },
    "hindi hip hop": {
        "frequency": 1,
        "average_age": 22.9,
        "percent_female": 14.0
    },
    "psychedelic hip hop": {
        "frequency": 1,
        "average_age": 30.5,
        "percent_female": 28.2
    },
    "underground hip hop": {
        "frequency": 1,
        "average_age": 27.5,
        "percent_female": 20.8
    },
    "latin arena pop": {
        "frequency": 1,
        "average_age": 34.6,
        "percent_female": 58.0
    },
    "alternative r&b": {
        "frequency": 1,
        "average_age": 30.3,
        "percent_female": 52.2
    },
    "indie soul": {
        "frequency": 2,
        "average_age": 32.9,
        "percent_female": 40.9
    },
    "la pop": {
        "frequency": 1,
        "average_age": 30.6,
        "percent_female": 50.4
    },
    "reggaeton": {
        "frequency": 1,
        "average_age": 27.8,
        "percent_female": 38.9
    },
    "reggaeton colombiano": {
        "frequency": 1,
        "average_age": 28.5,
        "percent_female": 49.6
    },
    "trap latino": {
        "frequency": 1,
        "average_age": 26.3,
        "percent_female": 33.1
    },
    "urbano latino": {
        "frequency": 1,
        "average_age": 26.8,
        "percent_female": 37.7
    },
    "dancefloor dnb": {
        "frequency": 1,
        "average_age": 30.1,
        "percent_female": 16.0
    },
    "drum and bass": {
        "frequency": 1,
        "average_age": 32.6,
        "percent_female": 17.0
    },
    "uk dance": {
        "frequency": 1,
        "average_age": 32.1,
        "percent_female": 34.9
    },
    "grime": {
        "frequency": 1,
        "average_age": 29.5,
        "percent_female": 18.8
    },
    "uk hip hop": {
        "frequency": 1,
        "average_age": 27.9,
        "percent_female": 21.8
    },
    "contemporary country": {
        "frequency": 4,
        "average_age": 34.7,
        "percent_female": 51.4
    },
    "country": {
        "frequency": 2,
        "average_age": 38.8,
        "percent_female": 43.6
    },
    "country road": {
        "frequency": 2,
        "average_age": 36.4,
        "percent_female": 45.2
    },
    "modern country rock": {
        "frequency": 2,
        "average_age": 34.7,
        "percent_female": 46.0
    },
    "filter house": {
        "frequency": 1,
        "average_age": 34.0,
        "percent_female": 24.4
    },
    "danish metal": {
        "frequency": 1,
        "average_age": 35.9,
        "percent_female": 13.2
    },
    "danish rock": {
        "frequency": 1,
        "average_age": 38.1,
        "percent_female": 29.8
    },
    "mongolian alternative": {
        "frequency": 1,
        "average_age": 28.3,
        "percent_female": 38.3
    },
    "oriental metal": {
        "frequency": 1,
        "average_age": 31.5,
        "percent_female": 21.5
    },
    "la indie": {
        "frequency": 2,
        "average_age": 31.4,
        "percent_female": 43.9
    },
    "glam rock": {
        "frequency": 1,
        "average_age": 42.3,
        "percent_female": 30.5
    },
    "mellow gold": {
        "frequency": 1,
        "average_age": 44.2,
        "percent_female": 34.7
    },
    "piano rock": {
        "frequency": 1,
        "average_age": 33.8,
        "percent_female": 44.0
    },
    "chamber ensemble": {
        "frequency": 1,
        "average_age": 0,
        "percent_female": 0
    },
    "classical cello": {
        "frequency": 1,
        "average_age": 39.4,
        "percent_female": 48.6
    },
    "classical performance": {
        "frequency": 1,
        "average_age": 44.0,
        "percent_female": 39.8
    },
    "rock drums": {
        "frequency": 1,
        "average_age": 42.0,
        "percent_female": 18.1
    },
    "alternative dance": {
        "frequency": 1,
        "average_age": 34.4,
        "percent_female": 33.4
    },
    "black americana": {
        "frequency": 2,
        "average_age": 39.5,
        "percent_female": 48.1
    },
    "country pop": {
        "frequency": 1,
        "average_age": 35.1,
        "percent_female": 51.5
    },
    "folk-pop": {
        "frequency": 1,
        "average_age": 34.1,
        "percent_female": 54.9
    },
    "irish pop": {
        "frequency": 1,
        "average_age": 33.4,
        "percent_female": 51.8
    },
    "uk pop": {
        "frequency": 1,
        "average_age": 31.9,
        "percent_female": 57.5
    },
    "classical piano": {
        "frequency": 1,
        "average_age": 40.9,
        "percent_female": 45.1
    },
    "russian classical piano": {
        "frequency": 1,
        "average_age": 41.4,
        "percent_female": 41.0
    },
    "chamber pop": {
        "frequency": 1,
        "average_age": 35.7,
        "percent_female": 40.1
    },
    "jam band": {
        "frequency": 1,
        "average_age": 40.6,
        "percent_female": 22.5
    },
    "melancholia": {
        "frequency": 1,
        "average_age": 38.7,
        "percent_female": 36.7
    },
    "stomp and holler": {
        "frequency": 1,
        "average_age": 35.2,
        "percent_female": 45.8
    },
    "outlaw country": {
        "frequency": 1,
        "average_age": 41.9,
        "percent_female": 24.8
    },
    "south african pop": {
        "frequency": 1,
        "average_age": 31.0,
        "percent_female": 40.5
    },
    "south african pop dance": {
        "frequency": 1,
        "average_age": 30.2,
        "percent_female": 40.9
    },
    "rebel blues": {
        "frequency": 1,
        "average_age": 31.2,
        "percent_female": 31.6
    },
    "bristol indie": {
        "frequency": 1,
        "average_age": 34.2,
        "percent_female": 32.0
    },
    "crank wave": {
        "frequency": 1,
        "average_age": 34.4,
        "percent_female": 26.7
    },
    "neo-rockabilly": {
        "frequency": 1,
        "average_age": 45.4,
        "percent_female": 17.1
    },
    "rockabilly": {
        "frequency": 1,
        "average_age": 46.0,
        "percent_female": 28.6
    },
    "indie surf": {
        "frequency": 1,
        "average_age": 31.5,
        "percent_female": 38.0
    },
    "french indie pop": {
        "frequency": 1,
        "average_age": 34.6,
        "percent_female": 45.9
    },
    "french pop": {
        "frequency": 1,
        "average_age": 34.8,
        "percent_female": 56.0
    },
    "french rock": {
        "frequency": 1,
        "average_age": 38.7,
        "percent_female": 33.1
    },
    "nouvelle chanson francaise": {
        "frequency": 1,
        "average_age": 39.4,
        "percent_female": 50.4
    },
    "afrofuturism": {
        "frequency": 1,
        "average_age": 33.4,
        "percent_female": 34.0
    },
    "contemporary jazz": {
        "frequency": 1,
        "average_age": 41.2,
        "percent_female": 23.4
    },
    "jazz": {
        "frequency": 1,
        "average_age": 41.0,
        "percent_female": 25.5
    },
    "jazz saxophone": {
        "frequency": 1,
        "average_age": 42.5,
        "percent_female": 26.0
    },
    "acoustic rock": {
        "frequency": 1,
        "average_age": 36.0,
        "percent_female": 26.3
    },
    "world": {
        "frequency": 1,
        "average_age": 39.0,
        "percent_female": 38.3
    }
}
);